import React from 'react';
import '../old.css';
export default function HeaderSection({ children, title='' , prefixClassName=''}) {
   return (
      <section className={`right-sec-cnt user-list-page emp_list ${prefixClassName}`} >
         <div className="add_delete_btn">
            <h2>{title}</h2>
         </div>
         {children}
      </section>
   );
}
